import { dateFormat, formatRatio, markFormatter, myValueFormatter, myValueFormatter_quantity, rateFormatter, valueFormatterUSDWithoutDecimals } from './commonFunctions';
// import { VALID_RATINGS } from 'src/common/constants';
import _ from 'lodash';
// import { dtcStatusColors, TradeStatus } from './constants';
import { dtcStatusColors, TradeStatus, VALID_RATINGS } from './constants'
import { valueFormatterUSD } from '../components/AgGrid/grid-util';

export const riskByCptyColDef = [
  {
    headerName: 'Acc No',
    field: 'trade_blazer_account_no',
    floatingFilter: false,
    editable: false,

    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isTBAccNoUpdate)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 60,
    maxWidth: 100,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Acc Short Name',
    field: 'trade_blazer_account_short_name',
    filter: 'agMultiColumnFilter',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isTBShortNameUpdate)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isTBShortNameUpdate &&
        _.isEmpty(params?.node?.data?.trade_blazer_account_short_name)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },

    hide: false,
    enableRowGroup: true,
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true
  },

  {
    headerName: 'Name',
    field: 'name',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (params.node.data.isNewRowInsert || (params?.node?.data?.isRowUpdated && params?.node?.data?.isNameUpdated)) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isNameUpdated &&
        _.isEmpty(params?.node?.data?.name)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 75,
    width: 65,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    enableRowGroup: true
  },
  {
    headerName: 'Bucket CB',
    field: 'bucket_cb',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isBucketCBUpdate)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isBucketCBUpdate &&
        isNaN(params?.node?.data?.bucket_cb)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 170,
    maxWidth: 250,
    suppressSizeToFit: false,
    sortable: true
  },

  {
    headerName: 'Bucket Estimated',
    field: 'bucket_estimated',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isBucketEstimatedUpdated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isBucketEstimatedUpdated &&
        isNaN(params?.node?.data?.bucket_estimated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 200,
    maxWidth: 250,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    hide: true
  },
  {
    headerName: 'PD Estimated',
    field: 'probability_of_default_estimated',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    filter: 'agMultiColumnFilter',
    cellDataType: 'text',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && _.isEmpty(params?.node?.data?.probability_of_default_estimated))
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isPDEstimatedUpdated &&
        isNaN(params?.node?.data?.probability_of_default_estimated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'CB Rating',
    field: 'cb_rating',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    filter: 'agMultiColumnFilter',
    cellDataType: 'text',
    floatingFilterComponentParams: { suppressFilterButton: true },

    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isCBRatingUpdated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isCBRatingUpdated &&
        (_.isEmpty(params?.node?.data?.cb_rating) ||
          !(VALID_RATINGS as readonly string[]).includes(params?.node?.data?.cb_rating?.toUpperCase()))
      ) {
        return {
          display: 'flex',
          alignItems: 'center',
          backgroundColor: TradeStatus.error
        }
      } else {
        if (
          params?.node?.data?.cb_rating?.toUpperCase() === 'AAA' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'AA+' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'AA-' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'AA'
        ) {
          return {
            display: 'flex',
            alignItems: 'center',
            color: '#10791A'
          }
        } else if (
          params?.node?.data?.cb_rating?.toUpperCase() === 'A+' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'A' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'A-'
        ) {
          return {
            display: 'flex',
            alignItems: 'center',
            color: '#437F25'
          }
        } else if (
          params?.node?.data?.cb_rating?.toUpperCase() === 'BBB' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'BBB-' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'BBB+'
        ) {
          return {
            display: 'flex',
            alignItems: 'center',
            color: '#64AC02'
          }
        } else if (
          params?.node?.data?.cb_rating?.toUpperCase() === 'BB' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'BB-' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'BB+'
        ) {
          return {
            display: 'flex',
            alignItems: 'center',
            color: '#F1A917'
          }
        } else if (
          params?.node?.data?.cb_rating?.toUpperCase() === 'B' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'B-' ||
          params?.node?.data?.cb_rating?.toUpperCase() === 'B+'
        ) {
          return {
            display: 'flex',
            alignItems: 'center',
            color: '#D3BB58'
          }
        } else if (_.startsWith(params?.node?.data?.cb_rating, 'C')) {
          return {
            display: 'flex',
            alignItems: 'center',
            color: '#BB7E47'
          }
        } else if (_.startsWith(params?.node?.data?.cb_rating, 'D')) {
          return {
            display: 'flex',
            alignItems: 'center',
            color: '#D62728'
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center'
          }
        }
      }
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Use Estimated',
    field: 'use_estimated',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isUSEEstimatedUpdated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isUSEEstimatedUpdated &&
        _.isEmpty(params?.node?.data?.use_estimated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Parent Account',
    field: 'parent_account',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isPatentAccountUpdated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isPatentAccountUpdated &&
        _.isEmpty(params?.node?.data?.parent_account)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 90,
    maxWidth: 120,
    suppressSizeToFit: false
  },
  {
    headerName: 'Id',
    field: 'id',
    floatingFilter: false,
    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    hide: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (params.node.data.isNewRowInsert || (params?.node?.data?.isRowUpdated && params?.node?.data?.isIdUpdated)) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isIdUpdated &&
        _.isEmpty(params?.node?.data?.id)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 250,
    maxWidth: 350,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Credit Acc Id',
    field: 'credit_account',
    filter: 'agMultiColumnFilter',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isCreditAccountUpdated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isCreditAccountUpdated &&
        _.isEmpty(params?.node?.data?.credit_account)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Inherit Parent Acc PD',
    field: 'inherit_parent_account_pd',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isInheritPatentAccPDUpdated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isInheritPatentAccPDUpdated &&
        _.isEmpty(params?.node?.data?.inherit_parent_account_pd)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Inherit Credit Acc PD',
    field: 'inherit_credit_account_pd',
    floatingFilter: false,

    // editable: true,

    editable: function (params: any) {
      if (params.node.data.isNewRowInsert) {
        return true
      } else {
        return false
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isInheritCreditAccPDUpdated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isInheritCreditAccPDUpdated &&
        _.isEmpty(params?.node?.data?.inherit_credit_account_pd)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter'
  },
  {
    headerName: 'PD Data',
    field: 'probability_of_default_cb',
    floatingFilter: false,

    editable: true,

    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isPDDefaultCBUpdated &&
        isNaN(params?.node?.data?.probability_of_default_cb)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isPDDefaultCBUpdated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 85,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'CC Allocation',
    field: 'cc_allocation',
    floatingFilter: false,
    editable: true,

    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: (params: any) => {
      if (
        params?.node?.data?.isRowUpdated &&
        params?.node?.data?.isCCAllocationUpdated &&
        isNaN(params?.node?.data?.cc_allocation)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: TradeStatus.error
        }
      } else if (
        params.node.data.isNewRowInsert ||
        (params?.node?.data?.isRowUpdated && params?.node?.data?.isCCAllocationUpdated)
      ) {
        return {
          display: 'flex',
          alignItems: 'center',

          backgroundColor: dtcStatusColors.pended
        }
      } else {
        return {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    valueFormatter: myValueFormatter
  }
]
export const riskFocusReportColDef = [
  {
    headerName: 'Id',
    field: 'focus_id',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 70,
    maxWidth: 110,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'P Begin',
    field: 'period_begin',
    filter: 'agMultiColumnFilter',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },

    hide: false,
    enableRowGroup: true,
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: dateFormat
  },

  {
    headerName: 'P End',
    field: 'period_end',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 75,
    width: 65,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    enableRowGroup: true,
    valueFormatter: dateFormat
  },
  {
    headerName: 'Sec File Num',
    field: 'sec_file_num',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 115,
    maxWidth: 160,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },

  {
    headerName: 'Firm Id',
    field: 'firm_id',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 105,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    hide: false
  },
  {
    headerName: 'Firm Name',
    field: 'firm_name',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    cellDataType: 'text',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 150,
    maxWidth: 350,
    suppressSizeToFit: false,
    sortable: true,
    hide: false
  },
  {
    headerName: 'Total Cap',
    field: 'total_cap',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    cellDataType: 'text',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: valueFormatterUSD
  },

  {
    headerName: 'Net Cap',
    field: 'net_cap',
    floatingFilter: false,
    editable: false,
    hide: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 150,
    maxWidth: 250,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: valueFormatterUSD
  },
  {
    headerName: 'Assets',
    field: 'assets',
    filter: 'agMultiColumnFilter',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: valueFormatterUSD
  },
  {
    headerName: 'Equity',
    field: 'equity',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: valueFormatterUSD
  },
  {
    headerName: 'Cash',
    field: 'cash',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: false,
    valueFormatter: valueFormatterUSD
  },
  {
    headerName: 'Cur Date',
    field: 'cur_date',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 105,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    valueFormatter: dateFormat
  },
  {
    headerName: 'Total Cur Assets',
    field: 'total_cur_assets',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: valueFormatterUSD
  },
  {
    headerName: 'Total Cur Liab',
    field: 'total_cur_liab',
    floatingFilter: false,
    editable: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    valueFormatter: valueFormatterUSD
  },
  {
    headerName: 'Cur Ratio',
    field: 'cur_ratio',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: formatRatio
  },
  {
    headerName: 'Quick Ratio',
    field: 'quick_ratio',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: formatRatio
  },
  {
    headerName: 'Cap Ratio',
    field: 'capital_ratio',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: formatRatio
  },
  {
    headerName: 'Total Deduct',
    field: 'total_deduct',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: valueFormatterUSD
  },
  {
    headerName: 'Total Haircut',
    field: 'total_haircut',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 90,
    maxWidth: 120,
    suppressSizeToFit: false,
    valueFormatter: valueFormatterUSD
  },
  {
    headerName: 'Sec Loan',
    field: 'sec_loan',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Liab Non Cust',
    field: 'liab_non_cust',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'ROE',
    field: 'roe',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Liab Cust',
    field: 'liab_cust',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Accounts Pay',
    field: 'accounts_pay',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Omnibus',
    field: 'omnibus',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Repo Sell',
    field: 'repo_sell',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },

  {
    headerName: 'Assets Clear Org',
    field: 'assets_clear_org',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Assets Other BD',
    field: 'assets_other_bd',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Liab Clear Org',
    field: 'liab_clear_org',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Equity Delta',
    field: 'equity_delta',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Fail Deliver',
    field: 'fail_deliver',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Sec Borrow',
    field: 'sec_borrow',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Liab Other BD',
    field: 'liab_other_bd',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Assets NON Cust',
    field: 'assets_non_cust',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Other Pay',
    field: 'other_pay',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Total Deduct',
    field: 'total_deduct',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Risk Limit Cash',
    field: 'risk_limit_cash',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Repo Buy',
    field: 'repo_buy',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Assets Cust',
    field: 'assets_cust',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Fail Receive',
    field: 'fail_receive',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Cash Delta',
    field: 'cash_delta',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Net Cap Delta',
    field: 'net_cap_delta',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    hide: true
  },
  {
    headerName: 'Updated Time',
    field: 'udpatetimedate',
    floatingFilter: false,
    editable: true,
    cellDataType: 'text',
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true
  }
]

export const liquidityRiskDashboardColDef = [
  {
    headerName: 'Id',
    field: 'id',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 120,
    suppressSizeToFit: false,
    sortable: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    },
    hide: true

    // enableRowGroup: true
  },
  {
    headerName: 'Cpty Id',
    field: 'cpty_id',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 120,
    suppressSizeToFit: false,
    sortable: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    },
    hide: false,

    enableRowGroup: true
  },
  {
    headerName: 'Name',
    field: 'name',
    hide: false,
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 130,
    maxWidth: 250,
    suppressSizeToFit: false,
    sortable: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    },
    enableRowGroup: true
  },

  {
    headerName: 'B/L',
    field: 'bl',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 70,
    maxWidth: 90,
    suppressSizeToFit: false,
    sortable: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values) && _.uniq(params.values)?.length === 1) {
        return _.uniq(params.values)
      } else {
        return ''
      }
    }
  },

  {
    headerName: 'Ticker',
    field: 'ticker',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 90,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    },
    enableRowGroup: true
  },
  {
    headerName: 'Price',
    field: 'price',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    valueFormatter: myValueFormatter,
    minWidth: 80,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },
  {
    headerName: 'Qty',
    field: 'shares',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 120,
    maxWidth: 170,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    valueFormatter: myValueFormatter_quantity,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },
  {
    headerName: 'Value',
    field: 'value',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    valueFormatter: myValueFormatter,
    minWidth: 120,
    maxWidth: 170,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },
  {
    headerName: 'CP PD',
    field: 'cb_pd',
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },
  {
    headerName: 'Float',
    field: 'flt',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    valueFormatter: myValueFormatter,
    minWidth: 120,
    maxWidth: 170,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    },
    hide: false
  },
  {
    headerName: 'ADTV-10',
    field: 'dtv',
    cellDataType: 'text',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    valueFormatter: myValueFormatter_quantity,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    },
    hide: false
  },

  {
    headerName: 'DTL',
    field: 'daystoliquidate',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    valueFormatter: myValueFormatter_quantity,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },

  {
    headerName: 'Liq Adj Val',
    field: 'riskadjval',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 120,
    maxWidth: 170,
    valueFormatter: myValueFormatter,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    },
    hide: true
  },

  {
    headerName: 'Liq Risk',
    field: 'liqrisk',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 120,
    maxWidth: 170,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    },
    hide: true
  },

  {
    headerName: 'Credit Account',
    field: 'credit_account',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 100,
    maxWidth: 250,
    hide: true,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agSetColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    }
  },
  {
    headerName: 'Parent Account',
    field: 'parent_account',
    type: 'rightAligned',
    hide: true,
    valueFormatter: myValueFormatter,
    floatingFilter: false,
    filter: 'agMultiColumnFilter',
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: 'flex',
        alignItems: 'center',

        justifyContent: 'flex-end'
      }
    },
    minWidth: 100,
    maxWidth: 250,
    suppressSizeToFit: false,
    sortable: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    }
  },

  {
    headerName: 'Potential GD',
    field: 'potentiallgd',
    filter: 'agMultiColumnFilter',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 75,
    maxWidth: 80,
    suppressSizeToFit: false,
    sortable: true,

    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    },
    hide: true
  },

  {
    headerName: 'EWMA Vol',
    field: 'ewma_vol',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: rateFormatter,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    },
    hide: true
  },

  {
    headerName: 'Cpty Allcoation',
    field: 'cpty_allcoation',
    valueFormatter: valueFormatterUSDWithoutDecimals,
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return '(0)'
      }
    },
    hide: true
  },
  {
    headerName: 'Cap Charge',
    field: 'capcharge',
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 115,
    width: 115,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',

    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },
  {
    headerName: 'Last Refreshed On',
    field: 'last_refreshed_on',
    floatingFilter: false,
    type: 'rightAligned',
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 120,
    maxWidth: 250,
    suppressSizeToFit: false,

    cellStyle: function () {
      return {
        display: 'flex',
        alignItems: 'center'
      }
    },
    sortable: true,
    hide: true
  }
]

export const liquidityRiskByContractsColDef = [
  {
    headerName: 'Cpty Id',
    field: 'cpty_id',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 80,
    maxWidth: 115,
    suppressSizeToFit: false,
    sortable: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    },
    hide: false

    // enableRowGroup: true
  },
  {
    headerName: 'Name',
    field: 'name',
    hide: true,
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 130,
    maxWidth: 250,
    suppressSizeToFit: false,
    sortable: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    }
  },

  {
    headerName: 'B/L',
    field: 'bl',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 60,
    maxWidth: 90,
    suppressSizeToFit: false,
    sortable: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values) && _.uniq(params.values)?.length === 1) {
        return _.uniq(params.values)
      } else {
        return ''
      }
    }
  },

  {
    headerName: 'Ticker',
    field: 'ticker',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 80,
    maxWidth: 110,
    suppressSizeToFit: false,
    sortable: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    }
  },
  {
    headerName: 'Price',
    field: 'price',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    valueFormatter: myValueFormatter,
    minWidth: 75,
    maxWidth: 110,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },
  {
    headerName: 'Qty',
    field: 'shares',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 110,
    maxWidth: 170,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    valueFormatter: myValueFormatter_quantity,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },
  {
    headerName: 'Value',
    field: 'value',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    valueFormatter: myValueFormatter,
    minWidth: 110,
    maxWidth: 170,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },
  {
    headerName: 'CP PD',
    field: 'cb_pd',
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 90,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    },
    hide: true
  },

  {
    headerName: 'ADTV-10',
    field: 'dtv',
    cellDataType: 'text',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 95,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    valueFormatter: myValueFormatter_quantity,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    },
    hide: false
  },

  {
    headerName: 'DTL',
    field: 'daystoliquidate',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 75,
    maxWidth: 120,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    valueFormatter: myValueFormatter_quantity,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },

  {
    headerName: 'Liq Adj Val',
    field: 'riskadjval',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 120,
    maxWidth: 170,
    valueFormatter: myValueFormatter,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    },
    hide: true
  },

  {
    headerName: 'Cpty Allcoation',
    field: 'cpty_allcoation',
    valueFormatter: myValueFormatter,
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return '(' + _.uniq(params.values).length + ')'
      } else {
        return '(0)'
      }
    },
    hide: true
  },
  {
    headerName: 'Cap Chrg',
    field: 'capcharge',
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 100,

    maxWidth: 170,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',

    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    }
  },
  {
    headerName: 'Float',
    field: 'flt',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    valueFormatter: myValueFormatter,
    minWidth: 75,
    maxWidth: 130,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.max(params.values)
      } else {
        return ''
      }
    },
    hide: false
  }
]

export const riskBySecColDef = [
  {
    headerName: 'Sec NBR',
    field: 'sec_nbr',
    floatingFilter: false,
    editable: false,
    rowGroup: true,
    hide: true,
    enableRowGroup: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    lockPinned: true,
    cellClass: 'lock-pinned',
    pinned: 'left'
  },
  {
    headerName: 'Contract Id',
    field: 'con_contract_id',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',

    // lockPinned: true,
    // cellClass: 'lock-pinned',
    // pinned: 'left',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 110,
    maxWidth: 170,
    suppressSizeToFit: false,
    // cellRenderer: ContractTradeActivity,
    sortable: true
  },
  {
    headerName: 'B/L',
    field: 'contract_type',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 80,
    maxWidth: 120,
    suppressSizeToFit: false,
    sortable: true

    // lockPinned: true,
    // cellClass: 'lock-pinned',
    // pinned: 'left'
  },
  {
    headerName: 'Cpty Id',
    field: 'short_name',
    filter: 'agMultiColumnFilter',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 95,
    maxWidth: 100,
    suppressSizeToFit: false,
    sortable: true
  },

  {
    headerName: 'Cpty Name',
    field: 'name1',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 170,
    maxWidth: 250,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Cusip',
    field: 'cusip',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true
  },

  {
    headerName: 'Security Name',
    field: 'sec_name',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 200,
    maxWidth: 250,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter'
  },
  {
    headerName: 'Status',
    field: 'status',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Portfolio',
    field: 'portfolio',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Acc NBR',
    field: 'account_nbr',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 90,
    maxWidth: 120,
    suppressSizeToFit: false
  },
  {
    headerName: 'Effective Date',
    field: 'effective_date',
    filter: 'agMultiColumnFilter',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Start Date',
    field: 'start_date',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'End Date',
    field: 'end_date',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter'
  },
  {
    headerName: 'Rate',
    field: 'rate',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 85,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    valueFormatter: rateFormatter
  },
  {
    headerName: 'Par',
    field: 'par',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    valueFormatter: rateFormatter
  },
  {
    headerName: 'Money',
    field: 'money',
    type: 'rightAligned',
    valueFormatter: myValueFormatter,
    floatingFilter: false,
    filter: 'agMultiColumnFilter',
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: 'flex',
        alignItems: 'center',

        justifyContent: 'flex-end'
      }
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Principal',
    field: 'principal',
    type: 'rightAligned',
    valueFormatter: myValueFormatter,
    floatingFilter: false,
    filter: 'agMultiColumnFilter',
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: 'flex',
        alignItems: 'center',

        justifyContent: 'flex-end'
      }
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    sortable: true
  },
  {
    headerName: 'Trade Date',
    field: 'trade_date',
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center'
    },
    minWidth: 125,
    maxWidth: 180,
    suppressSizeToFit: false,
    sortable: true,
    filter: 'agSetColumnFilter'
  },
  {
    headerName: 'DLV Price',
    field: 'dlv_price',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    type: 'rightAligned',
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueFormatter: myValueFormatter,
    cellStyle: function () {
      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      }
    },
    minWidth: 120,
    maxWidth: 180,
    sortable: true
  },

  {
    headerName: 'Con Price',
    field: 'con_price',
    floatingFilter: false,
    editable: false,
    filter: 'agMultiColumnFilter',
    type: 'rightAligned',
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueFormatter: myValueFormatter,
    cellStyle: function () {
      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      }
    },
    minWidth: 120,
    maxWidth: 180,
    sortable: true
  },

  {
    headerName: 'Sec Type',
    field: 'sec_type',
    floatingFilter: false,
    type: 'rightAligned',
    editable: false,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 80,
    maxWidth: 150,
    suppressSizeToFit: false,
    valueFormatter: markFormatter,
    cellStyle: function () {
      return {
        display: 'flex',
        alignItems: 'center'
      }
    },
    sortable: true
  }
]